import { SUPPORTED_UNITS } from '@/helpers/unit-formatter/unit-formatter.constants';
import { UnitTransformerType } from '@/helpers/unit-formatter/unit-formatter.types';

import { transformBoolean } from './transform-boolean';
import { transformCelsius } from './transform-celsius';
import { transformDuration } from './transform-duration';
import { transformFahrenheit } from './transform-fahrenheit';
import { transformHrs } from './transform-hrs';
import { transformHz } from './transform-hz';
import { transformMin } from './transform-min';
import { transformNone } from './transform-none';
import { transformPsi } from './transform-psi';
import { transformRatePerKwh } from './transform-rate-per-kwh';
import { transformSec } from './transform-sec';

/**
 * The transformers object is a registry of functions that are used to transform different units of measurement.
 * The key is the current units of the value being transformed.
 */
export const transformers: Record<string, UnitTransformerType> = {
  [SUPPORTED_UNITS.$_PER_KWH]: transformRatePerKwh,
  [SUPPORTED_UNITS.BOOLEAN]: transformBoolean,
  [SUPPORTED_UNITS.DEGREES_C]: transformCelsius,
  [SUPPORTED_UNITS.C]: transformCelsius, // alias for °c
  [SUPPORTED_UNITS.CELSIUS]: transformCelsius, // alias for °c
  [SUPPORTED_UNITS.DEGREES_F]: transformFahrenheit,
  [SUPPORTED_UNITS.F]: transformFahrenheit, // alias for °f
  [SUPPORTED_UNITS.FAHRENHEIT]: transformFahrenheit, // alias for °f
  [SUPPORTED_UNITS.HRS]: transformHrs,
  [SUPPORTED_UNITS.HZ]: transformHz,
  [SUPPORTED_UNITS.MIN]: transformMin,
  [SUPPORTED_UNITS.NONE]: transformNone,
  [SUPPORTED_UNITS.PSI]: transformPsi,
  [SUPPORTED_UNITS.PSIA]: transformPsi,
  [SUPPORTED_UNITS.PSIG]: transformPsi,
  [SUPPORTED_UNITS.PSIG_INHG]: transformPsi,
  [SUPPORTED_UNITS.SEC]: transformSec,
  [SUPPORTED_UNITS.DURATION]: transformDuration,
  [SUPPORTED_UNITS.TIMER]: transformDuration,
};

export default transformers;
